export const MAX_INVITEES_COUNT = 200;
